var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.stepNumber == 0 ? "block" : "hidden" }, [
    _c("input", {
      attrs: { type: "hidden", name: "person[0][facebook_id]" },
      domProps: { value: _vm.facebookId }
    }),
    _vm._v(" "),
    _c("h1", { staticClass: "registration-form-layout__title" }, [
      _vm._v(_vm._s(_vm.subscriptionsFormTitle))
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "registration-form registration-form-layout flex" },
      [
        _c("h3", { staticClass: "registration-form-layout__block-title" }, [
          _vm._v(_vm._s(_vm.businessTitle))
        ]),
        _vm._v(" "),
        _c("theme-toggler", {
          attrs: {
            name: "business-registration",
            label: _vm.businessLabel,
            value: _vm.business_state
          },
          on: { click: _vm.triggerBusinessForm }
        }),
        _vm._v(" "),
        _vm.business_state == "1"
          ? _c(
              "div",
              {
                staticClass:
                  "grid grid-cols-1 gap-x-4 gap-y-5 sm:grid-cols-2 md:gap-y-7",
                attrs: { id: "business-form" }
              },
              [
                _c("theme-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "`required`"
                    }
                  ],
                  attrs: {
                    label: _vm.companyName,
                    name: _vm.companyNameInput,
                    isRequired: true,
                    placeholder: _vm.companyNamePlaceholder
                  }
                }),
                _vm._v(" "),
                _c("theme-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "`required`"
                    }
                  ],
                  attrs: {
                    label: _vm.companyLegalForm,
                    name: _vm.companyLegalFormInput,
                    isRequired: true,
                    placeholder: _vm.companyLegalFormPlaceholder
                  }
                }),
                _vm._v(" "),
                _c("theme-input", {
                  attrs: {
                    label: _vm.companyChamberOfCommerceNumber,
                    name: _vm.companyChamberOfCommerceNumberInput,
                    placeholder: _vm.companyChamberOfCommerceNumberPlaceholder
                  }
                }),
                _vm._v(" "),
                _c("theme-input", {
                  attrs: {
                    label: _vm.companyVatNumber,
                    name: _vm.companyVatNumberInput,
                    placeholder: _vm.companyVatNumberPlaceholder
                  }
                }),
                _vm._v(" "),
                _c("theme-input", {
                  attrs: {
                    label: _vm.companyPhoneNumber,
                    name: _vm.companyPhoneNumberInput,
                    placeholder: _vm.companyPhoneNumberPlaceholder
                  }
                }),
                _vm._v(" "),
                _c("theme-input", {
                  attrs: {
                    label: _vm.companyEmail,
                    name: _vm.companyEmailInput,
                    placeholder: _vm.companyEmailPlaceholder
                  }
                }),
                _vm._v(" "),
                _c("theme-input", {
                  attrs: {
                    label: _vm.companyInvoiceEmail,
                    name: _vm.companyInvoiceEmailInput,
                    placeholder: _vm.companyInvoiceEmailPlaceholder
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.business_state == "0"
          ? _c("h3", { staticClass: "registration-form-layout__block-title" }, [
              _vm._v(_vm._s(_vm.subscriptionsYourRentalPreferences))
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.business_state == "0"
          ? _c(
              "div",
              {
                staticClass: "flex flex-col gap-4 md:gap-6",
                attrs: { id: "personal-form" }
              },
              [
                _c("theme-radios", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required|make_choice",
                      expression: "`required|make_choice`"
                    }
                  ],
                  attrs: {
                    label: _vm.subscriptionsFamilyTypeInputTitle,
                    name: _vm.subscriptionsFamilyTypeInput,
                    options: _vm.subscriptionsFamilyTypeOptions,
                    isRequired: true
                  },
                  on: { input: _vm.triggerFamilyType }
                }),
                _vm._v(" "),
                _vm.family_type_state == "several_friends"
                  ? _c("theme-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|numeric|min_value:0|max_value:5",
                          expression:
                            "`required|numeric|min_value:0|max_value:5`"
                        }
                      ],
                      attrs: {
                        name: "number_of_adults",
                        placeholder: _vm.subscriptionNumberOfAdultsPlaceholder,
                        label: _vm.subscriptionNumberOfAdults,
                        isRequired: true
                      },
                      on: { input: _vm.triggerAdultsNumber },
                      model: {
                        value: _vm.number_of_adults_value,
                        callback: function($$v) {
                          _vm.number_of_adults_value = _vm._n($$v)
                        },
                        expression: "number_of_adults_value"
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("h3", { staticClass: "registration-form-layout__block-title" }, [
          _vm._v(_vm._s(_vm.subscriptionsYourDetails))
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "grid grid-cols-1 gap-x-4 gap-y-5 sm:grid-cols-2 md:gap-y-7"
          },
          [
            _c("theme-input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "`required`"
                }
              ],
              attrs: {
                label: _vm.subscriptionsFirstName,
                name: _vm.subscriptionsFirstNameInput,
                placeholder: _vm.subscriptionsFirstNamePlaceholder,
                value: _vm.firstName,
                isRequired: true
              }
            }),
            _vm._v(" "),
            _c("theme-input", {
              attrs: {
                label: _vm.subscriptionsMiddleName,
                name: _vm.subscriptionsMiddleNameInput,
                placeholder: _vm.subscriptionsMiddleNamePlaceholder
              }
            }),
            _vm._v(" "),
            _c("theme-input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "`required`"
                }
              ],
              attrs: {
                label: _vm.subscriptionsLastName,
                name: _vm.subscriptionsLastNameInput,
                placeholder: _vm.subscriptionsLastNamePlaceholder,
                value: _vm.lastName,
                isRequired: true
              }
            }),
            _vm._v(" "),
            _c("theme-calendar", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "`required`"
                }
              ],
              attrs: {
                label: _vm.subscriptionsDateOfBirth,
                name: _vm.subscriptionsDateOfBirthInput,
                placeholder: _vm.subscriptionsDateOfBirthPlaceholder,
                isRequired: true
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c("theme-input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required|phone_number",
                  expression: "`required|phone_number`"
                }
              ],
              staticClass: "js-unique-phone",
              attrs: {
                label: _vm.subscriptionsPhoneNumber,
                name: _vm.subscriptionsPhoneNumberInput,
                placeholder: _vm.subscriptionsPhoneNumberPlaceholder,
                isRequired: true
              },
              on: { blur: _vm.checkPhone }
            }),
            _vm._v(" "),
            !!_vm.is_phone_number_unique
              ? _c("div", { staticClass: "mt-2" }, [
                  _c("span", { staticClass: "text-[#FF695B] text-[12px]" }, [
                    _vm._v(_vm._s(_vm.phoneNumberAlreadyExists))
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "`required`"
                      }
                    ],
                    attrs: { type: "hidden", name: "phone_number_unique" }
                  })
                ])
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c("theme-input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required|email",
                  expression: "`required|email`"
                }
              ],
              staticClass: "js-unique-mail",
              attrs: {
                label: _vm.subscriptionsEmail,
                name: _vm.subscriptionsEmailInput,
                placeholder: _vm.subscriptionsEmailPlaceholder,
                value: _vm.email,
                isRequired: true
              },
              on: { blur: _vm.checkMail }
            }),
            _vm._v(" "),
            _vm.is_user_already_exists == 1
              ? _c("div", { staticClass: "mt-2" }, [
                  _c("span", { staticClass: "text-[#FF695B] text-[12px]" }, [
                    _vm._v(_vm._s(_vm.isUserAlreadyExists))
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "`required`"
                      }
                    ],
                    attrs: { type: "hidden", name: "user_already_exists" }
                  })
                ])
              : _vm.is_user_already_exists == 2
              ? _c("div", { staticClass: "mt-2" }, [
                  _c("span", { staticClass: "text-[#FF695B] text-[12px]" }, [
                    _vm._v(_vm._s(_vm.isUserBanned))
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "`required`"
                      }
                    ],
                    attrs: { type: "hidden", name: "user_already_exists" }
                  })
                ])
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "grid grid-cols-1 gap-x-4 gap-y-5 sm:grid-cols-2 md:gap-y-6"
          },
          [
            _c("theme-input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "`required`"
                }
              ],
              ref: "password0",
              attrs: {
                label: _vm.subscriptionsPassword,
                name: _vm.subscriptionsPasswordInput,
                type: "password",
                placeholder: _vm.subscriptionsPasswordPlaceholder,
                isRequired: true
              }
            }),
            _vm._v(" "),
            _c("theme-input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required|confirmed:password0",
                  expression: "`required|confirmed:password0`"
                }
              ],
              attrs: {
                label: _vm.subscriptionsPasswordRepeat,
                type: "password",
                name: _vm.subscriptionsPasswordRepeatInput,
                placeholder: _vm.subscriptionsPasswordRepeatPlaceholder,
                isRequired: true
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _vm._l(_vm.number_of_adults_value_computed - 1, function(adult) {
          return _vm.number_of_adults_value > 1
            ? _c(
                "div",
                { key: adult },
                [
                  _c("registration-inner-form", {
                    attrs: {
                      i: adult,
                      "users-first-name": _vm.subscriptionsFirstName,
                      "users-first-name-placeholder":
                        _vm.subscriptionsFirstNamePlaceholder,
                      "users-middle-name": _vm.subscriptionsMiddleName,
                      "users-middle-name-placeholder":
                        _vm.subscriptionsMiddleNamePlaceholder,
                      "users-last-name": _vm.subscriptionsLastName,
                      "users-last-name-placeholder":
                        _vm.subscriptionsLastNamePlaceholder,
                      "users-date-of-birth": _vm.subscriptionsDateOfBirth,
                      "users-date-of-birth-placeholder":
                        _vm.subscriptionsDateOfBirthPlaceholder,
                      "users-phone-number": _vm.subscriptionsPhoneNumber,
                      "users-phone-number-placeholder":
                        _vm.subscriptionsPhoneNumberPlaceholder,
                      "users-email": _vm.subscriptionsEmail,
                      "users-email-placeholder":
                        _vm.subscriptionsEmailPlaceholder,
                      isUserAlreadyExists: _vm.isUserAlreadyExists,
                      isUserBanned: _vm.isUserBanned,
                      phoneNumberAlreadyExists: _vm.phoneNumberAlreadyExists
                    }
                  })
                ],
                1
              )
            : _vm._e()
        }),
        _vm._v(" "),
        _c("theme-checkboxes", {
          directives: [
            {
              name: "validate",
              rawName: "v-validate",
              value: "required",
              expression: "`required`"
            }
          ],
          staticClass: "form__radio",
          attrs: {
            options: {
              "1":
                _vm.agreeWithConditionsText +
                " <a href=" +
                _vm.generalTermsLink +
                " target='_blank' class='text-[#FF8212] hover:underline'>" +
                _vm.generalTermsLinkText +
                "</a><span class='theme-input__label-asterisk'>*</span>"
            },
            name: "terms_conditions",
            isRequired: true
          }
        }),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "theme-btn theme-btn--theme theme-btn--block",
            attrs: { id: "submitFormBtn", type: "submit" },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.submitForm.apply(null, arguments)
              }
            }
          },
          [_vm._v("\n      " + _vm._s(_vm.commonCreateAccount) + "\n    ")]
        )
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-07bb2108", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07bb2108","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/RegistrationForm.vue
// module id = 656
// module chunks = 1